import { API_ROUTE_auth_info } from "../Routes";
import { API } from "./API";
import { UserInfoDTO } from "./DTOs";

export class AuthDAO {
    static async Info(): Promise<UserInfoDTO | null> {
        const result = await API.Call_GET(API_ROUTE_auth_info, {});
        if (result.code === API.CODE_OK) {
            return result.data as UserInfoDTO;
        }
        else {
            return null;
        }
    }
}